import { useState } from 'react';
import { TestRuns, TestRunsExpandedRow } from '@elementary/common-ui/pages';
import { DEFAULT_DAYS_BACK } from '@elementary/common-ui/constants';
import useReport from '@/shared/hooks/useReport';
import useSnackbar from '@/shared/hooks/useSnackbar';
import useReportTestRuns from '../hooks/useReportTestRuns';

const TestRunsPage = () => {
  const [search, setSearch] = useState('');
  const { reportData } = useReport();
  const { openSnackbar } = useSnackbar();

  const data = useReportTestRuns({ reportData });

  return (
    <TestRuns
      {...data}
      daysBack={reportData?.days_back || DEFAULT_DAYS_BACK}
      search={search}
      onSearch={setSearch}
      expandedRowRenderer={(rowData) => (
        <TestRunsExpandedRow
          rowData={rowData}
          invocations={rowData.test_runs.invocations}
          onOpenSnackbar={(message) => openSnackbar({ message })}
        />
      )}
    />
  );
};

export default TestRunsPage;
